import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import BaseForm, { FieldOverrides } from '@/components/Form';
import { Modal } from '@/components/Modals';
import { ModalVariant } from '@/components/Modals/types';
import { PreserveModalForm } from '@/components/PreserveModalForm';

import useCreateFeedbackRequest from '../../hooks/useCreateFeedbackRequest';
import { CreateFeedbackRequestModalStyles } from './styles';
import { InitialFormValueType, RequestFeedbackModalProps } from './types';

const OVERRIDES: FieldOverrides = {
  Section: {
    spacing: 'space-y-32',
    Name: {
      variant: 'heading-xs',
    },
    Header: {
      className: 'mb-16 ms-8 space-y-8',
    },
  },
  spacing: {
    row: 'space-y-24',
  },
};

const RequestFeedbackModal: React.FC<RequestFeedbackModalProps> = (props) => {
  const {
    submitRef,
    fetching,
    fields,
    sections,
    setSubmitRef,
    validate,
    onSubmit,
    onChange,
    selectedValues,
    onCloseModal,
    modalClosePrompt,
  } = useCreateFeedbackRequest(props);
  const { t } = useTranslation();

  return (
    <PreserveModalForm {...modalClosePrompt}>
      <Modal
        action={{
          text: t('Feedback:RequestFeedback.SendRequest'),
          onSubmit: submitRef,
          appearance: 'primary',
          isSubmitting: fetching,
        }}
        className="px-32 pb-24"
        classes={{
          paper: CreateFeedbackRequestModalStyles,
        }}
        header={{
          title: t('Feedback:RequestFeedback.Title'),
          description: t('Feedback:RequestFeedback.Description'),
          classes: {
            description: 'mb-32',
          },
        }}
        showCloseBtn={true}
        variant={ModalVariant.Wide}
        onClose={onCloseModal}>
        <BaseForm<InitialFormValueType>
          fields={fields}
          formName="SetupMeeting"
          initialValues={selectedValues}
          overrides={OVERRIDES}
          sectionLayout={sections}
          setSubmitRef={setSubmitRef}
          validate={validate}
          onChange={onChange}
          onSubmit={onSubmit}
        />
      </Modal>
    </PreserveModalForm>
  );
};

export default RequestFeedbackModal;
